import type { FC } from 'react';
import type { PlainAction } from '@components/types';
import { Button } from '@components/ui/button';

interface ActionButtonProps {
  action: PlainAction;
}

export const ActionButton: FC<ActionButtonProps> = ({ action: { label, disabled, onClick } }) => (
  <div className="md:pl-0">
    <Button disabled={disabled} aria-disabled={disabled} type="button" variant="primary" onClick={onClick}>
      {label}
    </Button>
  </div>
);
